"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDeviceEventObserverToSession = addDeviceEventObserverToSession;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _ModalTypes = require("@studio/constants/ModalTypes");
var logger = new _StudioLogger.StudioLogger('chime-sdk-events');
function addDeviceEventObserverToSession(dispatch, showModal, meetingSession) {
  if (!meetingSession.deviceController.eventController) {
    console.info('Cannot add eventController observer to deviceController as no eventController has been created.');
    return;
  }
  meetingSession.deviceController.eventController.addObserver({
    eventDidReceive: function eventDidReceive(eventName) {
      var meetingId = meetingSession.configuration.meetingId;
      var logPayload = {
        'studio.meeting.id': meetingId,
        title: "Chime session eventController raised event: ".concat(eventName)
      };
      logger.info(logPayload.title, logPayload);
      if (['audioInputFailed'].includes(eventName)) {
        dispatch(showModal(_ModalTypes.AUDIO_INPUT_FAILED));
      }
    }
  });
}